<template lang="pug">
  #system-error
    .container.body-width.pt-3
      b-card.mt-1.form-box.mx-auto.text-center.justify-content-center(body-class="px-5")
        h2.mt-5.font-weight-bold.text-muted.white-space システムエラー
        p.mx-auto.mt-5.mb-3.white-space 申し訳ありません、{{error_msg}}でエラーが発生しました。
        p.mx-auto.mt-3.mb-4.white-space しばらくお時間をおいてから、再度アクセスしてください。
</template>

<script>
export default {
  name: "SystemError",
  props: {
    error_msg: {type: String, required: true}
  },
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
</style>